import React, { useState } from 'react';
import { MCButton, View } from '../basic';
import { remCss } from 'src/helpers';
import moment from 'moment';
import mainModel, { models, STEPS } from './model';
import { BASE_ICONS } from 'components/svg';
import { AddSlotPanel } from 'components/slotSchedule/EditSlot';
import { SlotList } from 'components/slotSchedule/SlotList';

const model = models[STEPS.SLOTS_OF_DAYS];

export const SlotsOfDay = ({ onHide, onPrev }) => {
  model.use();
  const { selectedDay, slot, addHour } = model.state;
  const doctorId = mainModel.state.doctorId;

  const [openAdd, setOpenAdd] = useState(addHour);
  const [slots, setSlots] = useState([]);

  return (
    <>
      <div className='mc-flex-20 mc-modal-header' style={{ position: 'relative' }}>
        {onPrev && (
          <MCButton
            width={40}
            iconname={BASE_ICONS.BACK_ARROW}
            primary
            onClick={onPrev}
            style={{ marginVertical: -10 }}
          />
        )}
        <div className='mc-popup-title mc-grow'>{moment(selectedDay).format('dddd (MMMM DD)')}</div>
        <AddSlotPanel
          openAdd={openAdd}
          setOpenAdd={setOpenAdd}
          day={selectedDay}
          slots={slots}
          addHour={addHour}
          showDate={false}
          onSaved={(err, data) => {
            if (data?.ok) {
              setOpenAdd(false);
              model.emit(`slot_schedule_slot_list_item`, { slot: data.data, isNew: true });
            }
          }}
        />
      </div>
      <View
        style={{
          flex: 1,
          marginRight: remCss(-10)
        }}
      >
        {selectedDay && (
          <SlotList
            onSlots={setSlots}
            group={false}
            startDate={moment(selectedDay).startOf('day').valueOf()}
            endDate={moment(selectedDay).endOf('day').valueOf()}
            doctorId={doctorId}
            onHide={onHide}
            slot={slot}
          />
        )}
      </View>
    </>
  );
};
